import { type TableRow } from '../../types';
import { Item } from './components';

interface ItemsProps<Item> {
    rows: TableRow<Item>[];
    selectedRowKey?: TableRow<Item>['key'];
    onClick?: (item: Item) => void;
}

export const Items = <Item,>({ rows, onClick, selectedRowKey }: ItemsProps<Item>) => {
    return rows.map((row) => {
        return (
            <Item
                key={row.key}
                row={row}
                onClick={onClick}
                selectedRowKey={selectedRowKey}
            />
        );
    });
};
